import classnames from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { ALERT_BANNER_TIMEOUT } from "src/constants";
import {
  ALERT_BANNER_TYPES,
  AlertBannerState as AlertBannerConnectedState
} from "src/shared/alertBanner/reducer";
import { State } from "src/state";
import CloseIcon from "../../documentUpload/close.svg";
import { resetAlertBanner } from "./actions";
import "./AlertBanner.scss";
import { getAlertBannerState } from "./selector";

interface AlertBannerProps {
  resetAlertBanner: typeof resetAlertBanner;
  alertBanner: AlertBannerConnectedState;
}

interface AlertBannerState {
  isOpen: boolean;
}

export class AlertBanner extends React.Component<
  AlertBannerProps,
  AlertBannerState
> {
  constructor(props: AlertBannerProps) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  public componentWillReceiveProps(nextProps: AlertBannerProps) {
    if (
      !this.state.isOpen &&
      !this.props.alertBanner &&
      nextProps.alertBanner
    ) {
      this.openBanner();
      this.closeBannerAfterTimer();
    } else if (this.state.isOpen) {
      this.closeBanner();
    }
  }

  public render() {
    if (!this.state.isOpen || !this.props.alertBanner) {
      return null;
    }

    const message = this.props.alertBanner.message || "Something went wrong.";
    const isSuccess =
      this.props.alertBanner.type === ALERT_BANNER_TYPES.SUCCESS;
    const isError = this.props.alertBanner.type === ALERT_BANNER_TYPES.ERROR;
    const isWarning =
      this.props.alertBanner.type === ALERT_BANNER_TYPES.WARNING;
    const isInfo = this.props.alertBanner.type === ALERT_BANNER_TYPES.INFO;

    return (
      <div
        className={classnames("AlertBanner", {
          "AlertBanner--success": isSuccess,
          "AlertBanner--error": isError,
          "AlertBanner--warning": isWarning,
          "AlertBanner--info": isInfo
        })}
      >
        <div className="AlertBanner__text">{message}</div>
        <div
          className="AlertBanner__close-icon-container"
          onClick={this.onClose}
        >
          <img src={CloseIcon} className="AlertBanner__close-icon" />
        </div>
      </div>
    );
  }

  private openBanner = () => {
    this.setState({ isOpen: true });
  };
  private closeBanner = () => {
    this.setState({ isOpen: false });
  };

  private closeBannerAfterTimer = () => {
    setTimeout(this.onClose, ALERT_BANNER_TIMEOUT);
  };

  private onClose = () => {
    this.closeBanner();
    this.props.resetAlertBanner();
  };
}

const mapStateToProps = (state: State) => ({
  alertBanner: getAlertBannerState(state)
});

export default connect(
  mapStateToProps,
  {
    resetAlertBanner
  }
)(AlertBanner);



// WEBPACK FOOTER //
// ./src/shared/alertBanner/AlertBanner.tsx